import Swal from 'sweetalert2';

function clickCameraIcon(){
    const selectBox = document.querySelectorAll('.thumb .list_select');
    const selectList = document.querySelectorAll('.thumb .list_select li');

    selectBox[0].style.display = "block";

    for(var i=0;i<selectList.length;i++){
        selectList[i].querySelector('a').onclick = function(){
            const thisSelect = this;
            this.style.backgroundColor = "rgb(247,247,247)";
            setTimeout(function(){
                selectBox[0].style.display = "none";
                thisSelect.style.backgroundColor = "rgb(255,255,255)";
            }, 100);
        }
    }
}

function autoHyphen(value) {
    value = value.replace(/[^0-9]/g, "");
    return value.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3");
}

function sweetAlert(title) {
	Swal.fire({
		html: title,
		width: 300,
		confirmButtonText: '확인',
		confirmButtonColor: '#9b0000',
	});
}

function showAlert(text, confirmButtonText = 'Yes') {
    return Swal.fire({
        text: text,
        confirmButtonText: confirmButtonText,
        confirmButtonColor: '#9b0000'
    }).then((result) => {
        return result.isConfirmed; // 확인 버튼을 눌렀을 때 true 반환
    });
}

export { clickCameraIcon, autoHyphen, sweetAlert, showAlert }